import styled from 'styled-components';

export const ContainerModalItems = styled.div`
  max-height: 99vh;
  width: 400px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px #4d4d4d;
  border-radius: 10px;
  padding: 16px;

  position: relative;
  margin: auto;
  box-sizing: border-box;
  overflow-y: auto;

  .title {
    display: block;
    color: ${({ tema }) => tema?.primaryColor};
    font-size: 24px;
    font-weight: bold;
  }

  .inputs-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 32px auto;
  }

  .terms-container {
    label {
      display: flex;
      gap: 8px;
      font-size: 14px;
      letter-spacing: 0.07px;

      input {
        margin: 0;
      }

      a {
        text-decoration: underline;
        font-weight: bold;
        color: ${({ tema }) => tema?.primaryColor};
      }
    }
  }

  .container-buttons {
    display: flex;
    flex-direction: column;

    gap: 12px;
  }

  @media (max-width: 768px) {
    width: 95vw;

    .inputs-container {
      margin: 18px auto;
    }
  }
`;
